<template>
    <div>

        <!-- header -->
        <div  >

            <!-- 1) imageContainer -->
            <div class="lc_imageContainer  TQ_borderRadius"
                 @mouseover="mouseover_b = true" @mouseleave="mouseover_b = false" v-if="pb_questExplore_c">

                <tq-images-slider v-if="mouseover_b || p_alwaysShowSlider_b"
                                  class="TQ_width_100p"
                                  :pb_images-files_ac="pb_questExplore_c.qex_imgsFiles_blc_ac[co_qex_displayLangCode_e]"
                                  :pb_elapsing-time_n="2000"
                                  :p_height_s="p_galleryHeight_s"
                                  :pb_uid_s="pb_questExplore_c.qex_questId_uid"/>

                <tq-img-fill-blur v-else
                                  class="TQ_width_100p TQ_borderRadius_top TQ_displayInherit"
                                  :p_height_s="p_galleryHeight_s "
                                  :p_att_s="pb_questExplore_c.qex_name_byLangCode_s[co_qex_displayLangCode_e]"
                                  :pp_img-url_s="pb_questExplore_c.qex_imgsFiles_blc_ac[co_qex_displayLangCode_e][0] && pb_questExplore_c.qex_imgsFiles_blc_ac[co_qex_displayLangCode_e][0].fi_url_s"/>

                <div class="lc_loveImage TQ_clickable "
                     :style="{'zIndex': gv_zIndex.tqQuestExploreHeader_btns}"
                     @click.prevent="m_loveQuest_f">
                    <tq-image v-show="pf_lovedQuest_b"  class="TQ_width_28px TQ_padding_8px " :pb_src_r="ass_img_heart_full"  />
                    <tq-image v-show="!pf_lovedQuest_b" class="TQ_width_28px TQ_padding_8px " :pb_src_r="ass_img_heart_empty" />
                </div>


                <div v-if="pf_displayActiveStatus_b && pb_questExplore_c.qex_metadata_c && pb_questExplore_c.qex_metadata_c.qexm_active_b"
                     class="lc_inStore TQ_bg_green" :style="{'zIndex': gv_zIndex.tqQuestExploreHeader_btns}">
                    {{ass_strings.twoWords_inStore[ps_langCode_e]}}
                </div>

                <div v-if="pb_questExplore_c && pb_questExplore_c.qex_metadata_c && pb_questExplore_c.qex_metadata_c.qeam_closedQuest_b"
                     class="lc_coronaVirus TQ_width_100p TQ_borderBox TQ_bg_gold TQ_box_shadow TQ_text_24px TQ_font_SecularOne">
                    {{ass_strings.sentence_closedCoronavirus[ps_langCode_e]}}
                </div>

            </div>

            <!-- 2) info -->
            <div class="TQ_margin_0_8px TQ_grid_row_1frAuto">

                <!-- Title -->
                <div class="TQ_textAlign_initial  TQ_padding_4px_0 TQ_margin_bottom_8px TQ_text_wordWrap_breakAll TQ_text_bold"
                    :class="pf_smallMode_b ? 'TQ_text_20px' : 'TQ_text_28px'">
                    {{co_questTitle_s}}
                </div>

                <!-- Participated And Reviews -->
                <div class="TQ_text_bold TQ_text_14px" v-if="pf_smallMode_b && pb_questExploreInfo_c">

                    <div class=" TQ_grid_col_1fr1fr">

                        <div class="TQ_grid_verticalCenter TQ_align_initial">

                            <tq-image :pb_src_r="ass_img_star" class="TQ_width_12px TQ_verticalAlignMiddle"/>
                            <div class="TQ_padding_1px TQ_inline TQ_verticalAlignMiddle"></div>
                            <div class="TQ_textColor_gold TQ_inline TQ_verticalAlignMiddle">
                                {{pb_questExploreInfo_c.qexi_overallRatingAvg_n.toFixed(1)}}
                            </div>
                            <div class="TQ_padding_2px TQ_inline TQ_verticalAlignMiddle"></div>
                            <div class="TQ_inline TQ_textColor_gray12 TQ_verticalAlignMiddle">
                                ({{format_bigNumber_fs(pb_questExploreInfo_c.qexi_reviewedNum_n)}})
                            </div>

                        </div>

                        <div class="TQ_grid_verticalCenter TQ_textColor_gray12 TQ_align_end">
                            {{format_bigNumber_fs(pb_questExploreInfo_c.qexi_participated_n)}} {{ass_strings.oneWord_players[ps_langCode_e]}}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- userData -->
        <div v-if="pb_createdUserData_c && pf_smallMode_b" class="lc_userInfo TQ_border_gray4 TQ_textAlign_initial TQ_grid_col_Auto1frAuto">

            <div class="TQ_inlineGrid TQ_grid_verticalCenter">
                <tq-avatar :p_ud_avatar_c="pb_createdUserData_c.ud_avatar_c"
                           :class="helper_getDirectionByLangCode_fe(ps_langCode_e)"
                           class="lc_userPhoto TQ_width_52px"/>
            </div>

            <div class="TQ_grid_verticalCenter TQ_inline TQ_text_14px">
                <div class="TQ_padding_2px">
                    <tq-image :pb_src_r="ass_img_user_bw" class="TQ_width_14px"/>
                    {{pb_createdUserData_c.ud_name_s}}
                </div>
                <div class="TQ_padding_2px TQ_text_capitalize">
                    <tq-image :pb_src_r="ass_img_location" class="TQ_width_14px"/>
                    <div v-if="pb_questExplore_c.qex_metadata_c.qexm_questLocationType_e === enum_questLocationsTypes_s.virtual"
                         class="TQ_inline TQ_bg_gold_lite TQ_padding_2px_8px TQ_borderRadius TQ_box_shadow TQ_margin_top_-2px ">
                        {{ass_strings.oneWord_virtual[ps_langCode_e]}}
                    </div>
                    <div v-else class="TQ_inline TQ_padding_2px_8px TQ_borderRadius TQ_margin_top_-2px ">
                        {{pb_questExplore_c.qex_startingLocation_s}}
                    </div>
                </div>
            </div>


            <div class="TQ_grid_verticalCenter TQ_padding_8px TQ_text_18px TQ_text_bold">
                {{pb_questExplore_c.cm_qex_costRange_s(p_system_currentCurrency_e, ps_langCode_e)}}
            </div>

            <!--<div class="TQ_grid_verticalCenter TQ_padding_8px TQ_center" v-if="pb_questExploreInfo_c && helper_getDiffObj_fo(pb_questExploreInfo_c.qexi_difficultyAvg_n).text_s !== '' ">-->
            <!--    <tq-image :pb_src_r="helper_getDiffObj_fo(pb_questExploreInfo_c.qexi_difficultyAvg_n).img_r" class="TQ_width_32px"/>-->
            <!--    <div class="TQ_text_12px TQ_margin_-4px">({{helper_getDiffObj_fo(pb_questExploreInfo_c.qexi_difficultyAvg_n).text_s[ps_langCode_e]}})</div>-->
            <!--</div>-->


        </div>

    </div>
</template>

<script>

    import Stars from "../a_smartIcons/si_Stars"

    import {format_bigNumber_fs, format_strMaxLength_s} from "../../../functions/src/shareCode/Share_S_Format";
    import TqOnTopContainer from "../basic/TqOnTopContainer";
    import {ass_strings} from "../../../functions/src/shareCode/Share_Ass_Dictionary";
    import {
        ass_img_edit, ass_img_flagFrench_c, ass_img_flagIsrael_c, ass_img_flagSpain_c, ass_img_flagUsa_c,
        ass_img_heart_empty, ass_img_heart_full,
        ass_img_location,
        ass_img_share, ass_img_star,
        ass_img_user_b,
    } from "@/assets/scripts/Ass_Files";
    import {validator_enum_fb} from "../../../functions/src/shareCode/Share_S_Validator";
    import {gv_strings, gv_zIndex} from "../../scripts/S_GlobalVar";
    import {
        enum_costCurrency_n,
        enum_questLocationsTypes_s,
    } from "../../../functions/src/shareCode/Share_S_Enum";
    import {helper_getDiffObj_fo, helper_getDirectionByLangCode_fe} from "../../scripts/S_Helper";
    import TqImagesSlider from "../basic/TqImagesSlider";
    import TqImage from "../basic/TqImage";
    import {FB_QuestExplore, FB_QuestExplore_Info, FB_UserData} from "../../../functions/src/shareCode/Share_S_Classes";
    import {enum_langCodes, enum_screenSizesOptions_n} from "../../../functions/src/shareCode/Share_S_Enum";
    import TqAvatar from "@/components/complex/TqAvatar";
    import TqImgFillBlur from "@/components/basic2/TqImgFillBlur";

    export default {
        name: 'TqQuestExploreHeader',
        components:{
            TqImgFillBlur,
            TqAvatar,
            TqImage,
            TqImagesSlider,
            TqOnTopContainer,
            Stars,
        },
        props:{
            // ========= basic ==========
            pb_questExplore_c : {
                type: FB_QuestExplore,
                require: true
            },
            pb_createdUserData_c :{
                type: FB_UserData,
                require: true
            },
            pb_questExploreInfo_c:{
                type: FB_QuestExplore_Info,
                require: true,
            },
            p_galleryHeight_s:{
                type: String,
                default: '200px'
            },

            // ========= system info ==========
            ps_langCode_e : {
                type:  String,
                require: true,
                validator(val){
                    return validator_enum_fb(enum_langCodes, val)
                }
            },
            p_system_currentCurrency_e : {
                type:  Number,
                require: true,
                validator(val){
                    return validator_enum_fb(enum_costCurrency_n, val)
                }
            },
            ps_screenSize_en:{
                type: Number,
                require: true,
                validator(val){
                    return validator_enum_fb(enum_screenSizesOptions_n, val)
                }
            },

            // ========= flags ==========
            pf_lovedQuest_b:{
                type: Boolean,
                default : false
            },
            pf_displayActiveStatus_b:{
                type: Boolean,
                default : false
            },
            p_alwaysShowSlider_b:{
                type: Boolean,
                default: false,
            },
            pf_smallMode_b: {
                type: Boolean,
                default : false
            },

            // ========= functions ==========
            pe_clickHeart_fe:{
                type: Function,
                default(){
                    return () => {}
                }
            },

        },
        data(){
            return{

                showPopup_share_vb : {val :false},
                swiperOption: {
                    centeredSlides: true,
                    spaceBetween: 30,
                    effect: 'fade',
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    },
                    autoplay: {
                        delay: 1500,
                        disableOnInteraction: false
                    },
                },
                lastShareDate_t : null,
                mouseover_b   : false,

                // imports
                ass_strings         : ass_strings,

                enum_questLocationsTypes_s : enum_questLocationsTypes_s,

                ass_img_location    : ass_img_location,
                ass_img_user_bw     : ass_img_user_b,
                ass_img_heart_empty : ass_img_heart_empty,
                ass_img_heart_full  : ass_img_heart_full,
                ass_img_share       : ass_img_share,
                ass_img_edit        : ass_img_edit,
                ass_img_star        : ass_img_star,
                gv_zIndex           : gv_zIndex,
                gv_strings          : gv_strings,
                ass_img_user_b      : ass_img_user_b,
                ass_img_flagIsrael_c: ass_img_flagIsrael_c,
                helper_getDiffObj_fo: helper_getDiffObj_fo,


                format_strMaxLength_s           : format_strMaxLength_s,
                format_bigNumber_fs             : format_bigNumber_fs,
                helper_getDirectionByLangCode_fe: helper_getDirectionByLangCode_fe,

            }
        },
        computed : {
            co_questTitle_s(){
                return format_strMaxLength_s(this.pb_questExplore_c.qex_name_byLangCode_s[this.co_qex_displayLangCode_e], 32)
            },
            co_qex_displayLangCode_e(){
                return this.pb_questExplore_c.cm_qex_getDisplayLang_fe(this.ps_langCode_e)
            },
            co_mobile_b(){
                return this.ps_screenSize_en === enum_screenSizesOptions_n.mobile && this.pf_smallMode_b
            }
        },
        methods:{
            m_loveQuest_f(){
                this.pe_clickHeart_fe(this.pb_questExplore_c)
            },
        },

    }
</script>

<style scoped lang="scss">


    .lc_imageContainer{
        position: relative;
        //width:100%;

        .lc_loveImage {
            position: absolute;
            left: 0;
            top: 0;
            display:inline-block;
            //border-right:  1px solid white;
            //border-bottom: 1px solid white;
            //border-top: 1px solid white;
            //border-radius: 0 5px 10px 0px;
            //padding:8px;
            /*background: var(--color-purple);*/
            color:white;
            //box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
        }

        .lc_inStore{
            position: absolute;
            display:inline-block;
            border-left:  1px solid white;
            border-bottom: 1px solid white;
            border-top: 1px solid white;
            border-radius: 5px 0 0 10px;
            right:0;
            top:16px;
            padding:6px 4px 6px 6px;
            /*background: var(--color-purple);*/
            color:white;
            box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
        }

        .lc_flag{
            position: absolute;
            left: 0;
            bottom: 16px;
            max-height: 50px;
        }

        .lc_coronaVirus{
            position: absolute;

            left: 50%;
            bottom: 16px;
            transform: translate(-50%,0);
            background-image: linear-gradient(gold, yellow, gold);
            border-bottom: 1px solid white;
            border-top: 1px solid white;
        }
    }
    
    .lc_userInfo {
        //border-top: 1px solid var(--color-gray1);

        .lc_userPhoto{
            &.rtl{
                border-radius: 0 0 4px 0;
            }
            &.ltr{
                border-radius: 0 0 0 4px;
            }
        }
    }
</style>
